import { Auth } from './Auth';
import { Public } from './Public';
import { Props } from './Props';
import { Notifications } from './Notifications';

export const actions = {
  AUTH: Auth,
  PUBLIC: Public,
  PROPS: Props,
  NOTIFICATIONS: Notifications,
};

export function RunAction({ type, state, payload, action }) {
  return actions[type] ? actions[type]({ state, payload, action }) : state;
}
